export const CONSENT = {
    ACCEPT_TEXT: 'This user accept the e.sy One terms of service and confirm that this user has read the e.sy One privacy policy and terms and conditions at '
}